import { kpiMarketplaceConstants } from "./../constants/kpiMarketplace.constants";

export {
  isExternalMetricV2AppId,
  isKpiIframeMetricTargetApp,
} from './kpi-v2-wizard-payload';

export const getExternalAppsFeatureFlag = (flagName, onlyEnabled = false) => {
    const results = {}; // map by appid.
    if (wbConfig.externalIntegrations) {
        // errorNotification
        wbConfig.externalIntegrations.reduce((acc, cur) => {
            const flag = cur?.featureFlags[flagName];
            if (onlyEnabled) {
                if (flag) {
                    results[+cur.id] = { visibility: flag, ext_app_id: +cur.id };
                }
            } else {
                results[+cur.id] = { visibility: flag, ext_app_id: +cur.id}
            }
            return acc;
        }, results);
    }
    return results;
}

export const getKpiExternalAppKpiTypeById = (externalAppId) => {
    externalAppId = +externalAppId;

    const map = kpiMarketplaceConstants.WOBO_EXT_APP_KPI_TYPE_MAP;
    if (wbConfig.externalIntegrations) {
        wbConfig.externalIntegrations.forEach((app) => {
            if (!map.has(+app.id)) {
                map.set(+app.id, app.app_name);
            }
        });
    }

    return map.has(externalAppId) ? map.get(externalAppId): '';
}

export const getKpiExternalAppDisplayNameById = (externalAppId) => {
    externalAppId = +externalAppId;
    const map = kpiMarketplaceConstants.WOBO_EXT_APP_DISPLAY_NAME_MAP;

    if (wbConfig.externalIntegrations) {
        wbConfig.externalIntegrations.forEach((app) => {
            if (!map.has(+app.id)) {
                map.set(+app.id, app.displayName);
            }
        });
    }

    return map.has(externalAppId) ? map.get(externalAppId): '';
}

export const getExternalAppIdByKpiType = (kpiType) => {
    const map = kpiMarketplaceConstants.WOBO_EXT_APP_ID_MAP;
    const externalAppList = wbConfig.externalIntegrations || [];

    for (const externalApp of externalAppList) {
        if (!map.has(externalApp.app_name)) {
            map.set(externalApp.app_name, +externalApp.id);
        }
    }
    
    return map.has(kpiType) ? map.get(kpiType) : null;
}

export const getExternalAppIconClass = (ex_app_id) => {
    ex_app_id = +ex_app_id;
    const map = kpiMarketplaceConstants.WOBO_EXT_APP_LOGO_MAP;

    return map.has(ex_app_id) ? map.get(ex_app_id) : '';
}

export const getExternalAppIconDataUri = (ex_app_id) => {
    ex_app_id = +ex_app_id;
    const map = new Map();

    if (wbConfig.externalIntegrations) {
        wbConfig.externalIntegrations.forEach((app) => {
            if (app.icon) {
                map.set(+app.id, app.icon);
            }
        });
    }

    return map.has(ex_app_id) ? map.get(ex_app_id): null;
}

export const isKpiMarketPlaceExternalApp = (ex_app_id) => {
    ex_app_id = +ex_app_id;
    const customAppIds = kpiMarketplaceConstants.KPI_MARKET_PLACE_CUSTOM_APP_ID;
    if (customAppIds.includes(ex_app_id)) {
        return true;
    }

    if (wbConfig.externalIntegrations) {
        for (const app of wbConfig.externalIntegrations) {
            if (+app.id === +ex_app_id && app.client_id === 'kpi-market-place') {
                return true;
            }
        }
    }

    return false;
}

/** @deprecated Import from kpi-v2-wizard-payload; kept for existing JS callers. */
export { getAutomatedTargetFromMetricData } from './kpi-v2-wizard-payload/metric-target';

export const useKpiMarketPlaceSourceLink = (ex_app_id) => {
    ex_app_id = +ex_app_id;
    const appIds = kpiMarketplaceConstants.KPI_MARKET_PLACE_CUSTOM_APP_SOURCE_LINK;
    if (appIds.includes(ex_app_id)) {
        return true;
    }

    return isKpiMarketPlaceExternalApp(ex_app_id);
}

const hasGoalIdValue = (value) => value !== null && value !== undefined && value !== '';

/**
 * Resolve the objective id for saveKr from a metric item and optional fallback goal context.
 */
export const resolveKrSaveGoalId = (item = {}, fallbackGoalDetails = null) => {
    if (hasGoalIdValue(item?.goal_id)) {
        return item.goal_id;
    }
    if (hasGoalIdValue(item?.cascade_goal_id)) {
        return item.cascade_goal_id;
    }
    if (hasGoalIdValue(item?.parent_goal_id)) {
        return item.parent_goal_id;
    }
    if (hasGoalIdValue(fallbackGoalDetails?.id)) {
        return fallbackGoalDetails.id;
    }
    return null;
};